import {useCallback, useEffect, useState} from 'react'

export const useStepFlow = ({initialStep, onStepChange, resetOnMount = true} = {}) => {
  const [currentStep, setCurrentStep] = useState(initialStep)
  const [params, setParams] = useState(null)
  const [history, setHistory] = useState([])

  const push = useCallback(
    (nextStep, nextParams = null) => {
      if (nextStep === currentStep) return

      setHistory(prev => [...prev, {step: currentStep, params}])
      setCurrentStep(nextStep)
      setParams(nextParams)

      onStepChange?.(nextStep)
    },
    [currentStep, params, onStepChange]
  )

  const goBack = useCallback(() => {
    if (history.length === 0) return

    const previousState = history[history.length - 1]
    const newHistory = history.slice(0, -1)

    setHistory(newHistory)
    setCurrentStep(previousState.step)
    setParams(previousState.params)

    onStepChange?.(previousState.step)
  }, [history, onStepChange])

  const reset = useCallback(() => {
    setCurrentStep(initialStep)
    setParams(null)
    setHistory([])

    onStepChange?.(initialStep)
  }, [initialStep, onStepChange])

  useEffect(() => {
    if (resetOnMount) {
      setCurrentStep(initialStep)
      setParams(null)
      setHistory([])
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [resetOnMount])

  const canGoBack = history.length > 0

  return {
    currentStep,
    params,
    canGoBack,
    push,
    goBack,
    reset
  }
}
